import * as t2 from "@/lib/SimulationReportModels";
import { clamp } from "@/lib/Util.jsx";

import type { PropertiesState } from "../reducers/properties.tsx";

export const order_uuid_line_offset_map = new Map<string, number>();

export let properties: PropertiesState | null = null;

export class ScrollHandler {
    static horizontalScroll = 0;

    static getChartScrollingEl() {
        return document.querySelector(".js-chart-scrollable");
    }

    static setChartScrollLeft(value: number) {
        this.horizontalScroll = value;
    }

    /**
     * When horizontal zoom (day width) changes, keep the same timeline point under
     * the center of the viewport.
     */
    static saveChartHorizontalScroll(zoomFactor: number) {
        const el = this.getChartScrollingEl();
        if (el && el.clientWidth > 0) {
            const { scrollLeft, clientWidth } = el;
            const value = (scrollLeft + clientWidth / 2) * zoomFactor - clientWidth / 2;
            this.horizontalScroll = clamp(value, 0, Infinity);
        }
    }

    static updateChartHorizontalScroll() {
        const el = this.getChartScrollingEl();
        if (el && el.clientWidth > 0) {
            const maxScroll = clamp(el.scrollWidth - el.clientWidth, 0, Infinity);
            const newScrollLeft = clamp(this.horizontalScroll, 0, maxScroll);
            el.scrollLeft = newScrollLeft;
        }
    }

    static addLineOffsetForScrollEvents(
        line_offset: number,
        orders: t2.ISimulationReportOrderEx[],
        in_properties: PropertiesState
    ) {
        for (const order of orders) {
            order_uuid_line_offset_map.set(order.order_id, line_offset);
        }
        properties = in_properties;
    }

    static scrollToOrder(order_id: string) {
        const el = document.querySelector(`[name='order-rect'][order-uuid='${order_id}']`);
        if (el) {
            el.scrollIntoView({ block: "center", inline: "center" });
        } else {
            const line_offset = order_uuid_line_offset_map.get(order_id) || 0;

            const pane1 = document.querySelector("#pane1");
            if (pane1) {
                const { height } = pane1.getBoundingClientRect();
                pane1.scrollTop = line_offset - height / 2;
            }
        }
    }

    static scrollToElement(order: Element) {
        order.scrollIntoView({ block: "nearest", inline: "center" });
    }
}
